import { gql } from "@apollo/client";
import { USER_FRAGMENT } from "./user.fragment";

export const UPDATE_PROFILE = gql`
  mutation UpdateProfile($data: UpdateUserInput!) {
    updateUser(data: $data) {
      ...User
    }
  }
  ${USER_FRAGMENT}
`;
